export default __webpack_public_path__ + "static/media/icon_moderator.6cbdba59.svg";